import { IButtonStyles, ILabelStyles } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../common/styles/common.styles';

export const getBottomLabelStyles = (): ILabelStyles => {
  return AppLayoutSettings.AppCommonStyles.getRegularLabelStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx,  AppLayoutSettings.getAppColorContainer().mediumLabelColor);
};

export const getRecordingButtonCustomStyles = (): Partial<IButtonStyles> => {
  return {
    root: {
      marginLeft: '20px',
      selectors: {
        [`:focus`]: {
          border: '1px solid transparent',
          outline: '1px solid',
          outlineColor: AppLayoutSettings.getAppColorContainer().keyboardFocusColor.value
        }
      }
    }
  };
};

export const getOneDriveIdentityInfoBarLandingPageStyles = (): React.CSSProperties => {
  const onedriveInfoBarOnLandingPageStyle: React.CSSProperties = {
    backgroundColor: AppLayoutSettings.getAppColorContainer().officeDesktopBackgroundColor.value,
    position: 'relative',
    paddingLeft: '10px',
    top: '2px',
  }

  return onedriveInfoBarOnLandingPageStyle;
};